import React, { useState, useRef, useEffect, ReactNode } from "react";
import ArrowDown from "@assets/icons/arrow-down.svg";
import styles from "./accordion.module.scss"; // styles below

interface AccordionProps {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
}

export const Accordion: React.FC<AccordionProps> = ({
  title,
  children,
  defaultOpen = false,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const [height, setHeight] = useState("0px");
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      setHeight(isOpen ? `${contentRef.current.scrollHeight}px` : "0px");
    }
  }, [isOpen]);

  return (
    <div className={styles.accordion} onClick={() => setIsOpen(!isOpen)}>
      <div className={styles.accordionHeader}>
        <span className={styles.accordionTitle}>{title}</span>
        <span className={`${styles.accordionArrow} ${isOpen ? styles.open : ""}`}>
          <ArrowDown />
        </span>
      </div>

      <div ref={contentRef} className={styles.accordionContent} style={{ height }}>
        <div className={styles.accordionInner}>{children}</div>
      </div>
    </div>
  );
};
